<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-pass-cause" class="control-label">{{ customField.title }}</label>
    <select
        class="form-control"
        v-model="inputValue"
        :disabled="disabled"
    >
      <option
          v-for="purpose in visibleAttributes()"
          v-bind:key="purpose.id"
          :value="purpose.id"
      >{{ purpose.value }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin';
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import passSectionMixin from '@/common/mixins/application-form/passSectionMixin';

export default {
  name: 'AppCustomFieldInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin
  ],

  props: {
    inputLabel: {
      default: ''
    },

    inputName: {
      default: 'customField'
    },

    items: {
      type: [Array, Object],
      default: () => []
    },

    customField: {
      type: Object
    }

  },
  created() {
    if (!this.isView) {
      let currentValue = this.form.application.custom_fields[this.customField.id]
      let currentValueVisible = this.customField.attributes.find((attribute) => Number(attribute.id) === Number(currentValue) && Number(attribute.visible) === 1)
      if (!currentValueVisible) {
        delete this.form.application.custom_fields[this.customField.id]
      }
    }
  },
  computed: {
    hasInputErrors () {
      return this.errors.application?.customFields !== undefined &&
        this.errors.application?.customFields[this.customField.id]
    }
  },
  methods: {
    visibleAttributes () {
      if (!this.isView) {
        return this.items.filter((item) => Number(item.visible) === 1)
      }

      return this.items
    }
  }
}
</script>
